export default "__VITE_ASSET__59741a55__"